import { FaTelegram, FaFacebookF, FaXTwitter, FaReddit } from "react-icons/fa6";

export const Footer = () => (
  <footer className="bg-gray-900 border-t border-gray-700 text-white text-sm mt-12">
    <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
      
      <div className="text-gray-400">
        © 2025 CoinzUp. All rights reserved.
      </div>

      <div className="flex flex-wrap items-center gap-4 text-gray-400">
        <a href="/terms" className="hover:text-white underline">
          Terms & Conditions
        </a>
        <a href="/notice" className="hover:text-white underline">
          Privacy & Legal Notice
        </a>
       
        <a
          href="https://www.facebook.com/profile.php?id=61576040825765"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white text-lg"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://x.com/coinzup2025"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white text-lg"
        >
          <FaXTwitter />
        </a>
        <a
          href="https://t.me/coinzup2025"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white text-lg"
        >
          <FaTelegram />
        </a>        
      </div>
    </div>
  </footer>
);
